import { render, staticRenderFns } from "./CategoriesPage.vue?vue&type=template&id=55459682"
import script from "./CategoriesPage.vue?vue&type=script&lang=js"
export * from "./CategoriesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports